'use client';

import { IconName, Tag } from '@bytel/trilogy-react';

import { EligibilityOptionType } from '@app-types/eligibility';

import { formatPrice } from '@helpers/wording';

export function SpeedOption({ speedOption }: Readonly<{ speedOption: EligibilityOptionType }>) {
    const label = speedOption.price
        ? `Option débit+ (${formatPrice(speedOption.price)}/mois)\u00A0↓ ${speedOption.speed_down} ↑ ${speedOption.speed_up}`
        : `Adresse éligible Débit+ ↓ ${speedOption.speed_down}\u00A0↑ ${speedOption.speed_up}`;
    return <Tag small iconName={IconName.CHECK_CIRCLE} className='text-wrap' label={label} />;
}
